import { all, call, fork, put, takeEvery } from "redux-saga/effects";
// Include call API
import { getUsersAPI } from "../../../api/users";
import { getUsersError, getUsersSuccess } from "./actions";
// Login Redux States
import { GET_USER } from "./actionTypes";



const usersAPI = getUsersAPI();

function* getAllUsers({ payload: { user, history } }) {
  try {
    const response = yield call(usersAPI.getUsers, user.token);
    yield put(getUsersSuccess(response.users, response.message));
  } catch (error) {
    yield put(getUsersError(error));
  }
}

export function* watchGetUsers() {
  yield takeEvery(GET_USER, getAllUsers);
}

function* getUsersSaga() {
  yield all([fork(watchGetUsers)]);
}

export default getUsersSaga;
